<template>
  <form data-vv-scope="login">
    <div class="number-prefix">
      <input
        class="col-12 form-control login-signup-input"
        type="text"
        placeholder="Email"
        v-validate="'required|email'"
        data-ismobileonly="false"
        name="email"
        v-model="email"
        :class="{ 'is-invalid': errors.has('login.email')}"
        id="login-form-email"
      >
      <div
        class="invalid-feedback"
        v-if="(errors.has('login.email') && showLoginError)"
        id="login-form-email-error"
      >
        {{ errors.first('login.email') }}
      </div>
      <input
        class="col-12 form-control login-signup-input mt-2 mb-2"
        type="password"
        placeholder="Password"
        data-ismobileonly="false"
        name="password"
        v-model="password"
        id="login-form-password"
        :class="{ 'is-invalid': errors.has('login.password')}"
        v-validate="'required|min:6'"
        ref="password"
      >
      <div
        class="invalid-feedback"
        v-if="(errors.has('login.password') && showLoginError)"
        id="login-form-password-error"
      >
        {{ errors.first('login.password') }}
      </div>
    </div>
    <button
      class="btn col-12 btn-lg blue-btn continue-btn mt-2"
      v-loading="loading"
      @click.prevent="action('login')"
      id="login-form-btn"
    >
      Login
    </button>
  </form>
</template>

<script>
export default {
	name: 'vendor-login-form',
	data () {
		return {
			email: '',
			password: '',
			loading: '',
			showLoginError: false
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.showLoginError = false
				} else {
					this.showLoginError = true
				}
			})
		},
		resetFormData () {
			this.email = ''
			this.password = ''
			this.showLoginError = false
		}
	}
}
</script>

<style scoped>
</style>
